<template>
  <GfrLayout class="app-layout">
    <GfrLayoutHeader class="app-layout-header !h-21 pointer-events-auto">
      <div class="app-nav">
        <GfrLogo :link="`/${$route.params.lang}/`" class="app-logo">
          <img class="w-full" src="~@/assets/images/logo.svg" alt="Logo" />
        </GfrLogo>
        <div class="app-nav-right">
          <CommonMenu class="app-menu" />
          <CommonSearch v-if="searchStatus" class="app-search" />
          <!-- <CommonMultiLanguage
            v-if="langList.length > 1"
            class="app-language"
            :list="langList"
            :global="globalLang"
            only-self
          /> -->
        </div>
      </div>
    </GfrLayoutHeader>
    <GfrLayoutMain class="app-layout-main">
      <slot />
    </GfrLayoutMain>
  </GfrLayout>
  <CommonScreenTips class="block landscape:hidden">
    <img class="app-screen-tips-img" src="@/assets/images/scape.png" alt="screen-tips" />
    <p class="app-screen-tips-text">Please rotate your device to landscape mode</p>
  </CommonScreenTips>
</template>
<script setup lang="ts">
const route = useRoute()
const router = useRouter()
const { inGame } = useGame()
const store = useStore()
const { config } = storeToRefs(store)
onBeforeMount(() => {
  if (inGame() || route.query.layout === 'cl' || session.getItem('layout') === 'cl') {
    if (route.query.layout === 'cl') {
      session.setItem('layout', 'cl')
      router.replace({ query: {} }) // clear query
    }
  } else {
    window.location.href = `/${route.params.lang}/`
  }
})
const searchStatus = computed(
  () =>
    config.value.config?.search_status &&
    (config.value.config?.search_terms_wiki_cl || config.value.config?.search_terms_tutorial_cl)
)
</script>
<style lang="scss" scoped>
.app-layout {
  @apply landscape:flex hidden;
  background-image: url('@/assets/images/global-bg.png');
  background-size: 100% auto;
  background-position: center top;
  background-repeat: repeat-y;
}
.app-layout-header {
  @apply bg-background;
  @apply border-b border-[#2B2D32];
}

.app-nav {
  @apply flex h-full items-center justify-start pl-17.5 pr-17;
}

.app-logo {
  @apply w-8.5 lg:mt-0.5 lg:w-8.5;
}

.app-nav-right {
  @apply flex h-full flex-1 items-center justify-end;
}

.app-menu {
  @apply flex-1 px-16;
}

.app-download {
  @apply hidden lg:block;
}

.app-search {
  // @apply ltr:lg:mr-6 rtl:lg:ml-6;
}

.app-language {
  @apply ltr:mr-5 ltr:lg:mr-11 rtl:ml-5 rtl:lg:ml-11;
}

.app-layout-main {
  @apply pt-21 w-full;
}

.app-footer-logo {
  @apply w-[250px];
}

.app-footer-contact {
  @apply lg:order-2 lg:mt-1 lg:max-w-[25%];
}
.app-screen-tips-img {
  @apply w-[40%];
  animation: rotate 1.2s ease-out infinite alternate;
}
.app-screen-tips-text {
  @apply mt-24 text-center text-[48px] text-white;
}
@keyframes rotate {
  0% {
    transform: rotate(-90deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
</style>
